// extracted by mini-css-extract-plugin
export default {"root":"lNzps2YPwyJL_7fBmjCz","placeHolderShimmer":"dTT6CPKFE_mtE_akWCrb"};